import { Component } from 'react';
import DisplayError from './DisplayError';
import { postClientCrashLog } from 'js/library/utils/API/clientCrashLogs';

const getValue = (value) => (typeof value === 'string' && value ? value : null);
const getTabId = () => sessionStorage.getItem('open_page');
const payloadFor = (error, info) => ({
  project: 'web-app',
  errorName: getValue(error?.name),
  message: getValue(error?.message),
  stack: getValue(error?.stack),
  componentStack: getValue(info?.componentStack),
  browserTabId: getTabId(),
  userAgent: getValue(navigator?.userAgent),
  language: getValue(navigator?.language),
  viewport: { width: window.innerWidth, height: window.innerHeight },
});

class ErrorBoundary extends Component {
  state = { hasError: false, error: null };
  static getDerivedStateFromError(error) { return { hasError: true, error }; }
  componentDidCatch(error, info) {
    void postClientCrashLog(payloadFor(error, info)).catch(() => console.warn('Falha técnica ao registrar crash do cliente.'));
  }
  render() { return this.state.hasError ? <DisplayError error={this.state.error} /> : this.props.children; }
}

export default ErrorBoundary;
